import React from 'react';
import { Grid } from '@mui/material';

const StarRatingHeader = ({ value, onChange, onFocus, onBlur, isReadOnly, HeadingColor }) => (
  <Grid className="HeadingInput" pb="14px">
    <input
      className="customHead-input"
      placeholder="یک عنوان وارد کنید"
      style={{
        border: 'none',
        outline: 'none',
        userSelect: 'text',
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
        width: '100%',
        fontSize: '16px',
        fontWeight: 700,
        lineHeight: 1.45,
        color: HeadingColor,
      }}
      readOnly={isReadOnly}
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  </Grid>
);

export default StarRatingHeader;
